import _ from "lodash";
import { formatDate, CustomMUIChip } from "../../../../common";

// Status dropdown values for the procurement approval column.
const PROC_STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "Accepted", label: "Accepted" },
  { value: "Rejected", label: "Rejected" },
];

// Item Status column maps the boolean isActive to Active / Inactive.
const ACTIVE_OPTIONS = [
  { value: "true", label: "Active" },
  { value: "false", label: "Inactive" },
];

/**
 * Column config for the All Items table. Each entry drives a DataGrid column
 * with an embedded per-column server-side search control (see
 * createSearchColumns / ColumnHeaderSearch). `search` is the control kind; each
 * `field` must match a key the backend whitelists in ITEM_SEARCHABLE_FIELDS
 * (itemListShared).
 */
export const allItemsColumnConfig = [
  {
    field: "status",
    minWidth: 200,
    search: "status",
    csvFormat: "startCase",
    statusOptions: PROC_STATUS_OPTIONS,
    valueGetter: (params) =>
      params.row.procurementApproval &&
      _.startCase(params.row.procurementApproval.status),
  },
  {
    field: "processedBy",
    minWidth: 200,
    search: "text",
    csvFormat: "naText",
    valueGetter: (params) =>
      params.row.procurementApproval.processedBy
        ? params.row.procurementApproval.processedBy
        : "N/A",
  },
  {
    field: "isActive",
    headerName: "Item Status",
    minWidth: 200,
    search: "status",
    csvFormat: "activeInactive",
    statusOptions: ACTIVE_OPTIONS,
    renderCell: (params) => {
      // Inactive only when explicitly false. A missing/undefined isActive means
      // active — the schema default is true and legacy items lack the field, so
      // `=== true` wrongly labelled those as Inactive (QRM-8099).
      const active = params.value !== false;
      return (
        <CustomMUIChip
          label={active ? "Active" : "Inactive"}
          status={active}
          variant="outlined"
          color={active ? "success" : "error"}
        />
      );
    },
  },
  { field: "sampleRequestID", minWidth: 200, search: "text" },
  { field: "sampleItemID", minWidth: 200, search: "text" },
  { field: "itemERPCode", minWidth: 200, search: "text" },
  { field: "itemDescription", minWidth: 200, search: "text" },
  { field: "specification", minWidth: 200, search: "text" },
  { field: "preferredUnitOfMeasure", minWidth: 200, search: "text" },
  { field: "quantityForSample", minWidth: 200, search: "text" },
  { field: "productClass", minWidth: 200, search: "text" },
  {
    field: "date",
    minWidth: 260,
    search: "date",
    type: "date",
    csvFormat: "date",
    valueFormatter: (params) =>
      params.value !== "pending" ? formatDate(params.value) : params.value,
  },
  {
    field: "needByDate",
    minWidth: 260,
    search: "date",
    type: "date",
    csvFormat: "date",
    valueFormatter: (params) =>
      params.value !== "pending" ? formatDate(params.value) : params.value,
  },
  { field: "purpose", minWidth: 200, search: "text" },
  { field: "endUserLocation", minWidth: 200, search: "text" },
  { field: "email", minWidth: 220, search: "text" },
];
